
import React from 'react';
import { UserIcon } from '../assets/icons';

const MOCK_USERS = [
    { id: 1, name: 'Rodrigo Ribeiro', role: 'Administrador', cr: 'CR-998877', status: 'Verificado', spent: 'R$ 142k', level: 'General' },
    { id: 2, name: 'Carlos Ferreira', role: 'Membro', cr: 'CR-112233', status: 'Verificado', spent: 'R$ 15k', level: 'Tenente' },
    { id: 3, name: 'Ana Souza', role: 'Membro', cr: 'CR-PENDENTE', status: 'Em Análise', spent: 'R$ 0', level: 'Soldado' },
    { id: 4, name: 'Marcos Silva', role: 'Membro', cr: 'CR-554433', status: 'Rejeitado', spent: 'R$ 2k', level: 'Soldado' },
    { id: 5, name: 'Julia Roberts', role: 'Vendedor', cr: 'CR-777888', status: 'Verificado', spent: 'R$ 450k', level: 'Parceiro' },
];

const AdminUsers: React.FC = () => {
    return (
        <div className="space-y-6 animate-fade-in">
            <div className="flex justify-between items-center">
                <h2 className="text-xl font-bold text-white uppercase tracking-wider flex items-center gap-2">
                    <UserIcon className="h-6 w-6 text-blue-500" />
                    Esquadrão (Usuários)
                </h2>
                <div className="flex gap-2">
                    <button className="bg-arsenal-red hover:bg-red-700 text-white px-4 py-2 rounded-lg text-sm font-bold uppercase transition-colors shadow-lg shadow-red-900/20">
                        Novo Operador
                    </button>
                    <button className="bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded-lg text-sm font-bold uppercase transition-colors">
                        Exportar Dados
                    </button>
                </div>
            </div>

            <div className="bg-gray-800/30 rounded-2xl border border-gray-700 overflow-hidden backdrop-blur-sm">
                <table className="w-full text-left text-sm text-gray-400">
                    <thead className="bg-gray-800 text-xs uppercase font-bold text-gray-300">
                        <tr>
                            <th className="px-6 py-4">Operador</th>
                            <th className="px-6 py-4">Status CR</th>
                            <th className="px-6 py-4">Nível</th>
                            <th className="px-6 py-4">Investimento Total</th>
                            <th className="px-6 py-4">Ações</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-700">
                        {MOCK_USERS.map((user) => (
                            <tr key={user.id} className="hover:bg-gray-700/30 transition-colors">
                                <td className="px-6 py-4 flex items-center gap-3">
                                    <div className="h-8 w-8 rounded-full bg-gray-700 flex items-center justify-center text-white font-bold text-xs ring-2 ring-gray-600">
                                        {user.name.charAt(0)}
                                    </div>
                                    <div>
                                        <div className="font-bold text-white">{user.name}</div>
                                        <div className="text-xs">{user.role}</div>
                                    </div>
                                </td>
                                <td className="px-6 py-4">
                                    <span className={`px-2 py-1 rounded text-[10px] font-black uppercase tracking-wide border ${user.status === 'Verificado' ? 'bg-green-500/10 text-green-400 border-green-500/20' :
                                        user.status === 'Em Análise' ? 'bg-amber-500/10 text-amber-400 border-amber-500/20' :
                                            'bg-red-500/10 text-red-400 border-red-500/20'
                                        }`}>
                                        {user.status}
                                    </span>
                                    <div className="text-[10px] mt-1 text-gray-500">{user.cr}</div>
                                </td>
                                <td className="px-6 py-4">
                                    <span className={`font-bold ${user.level === 'General' ? 'text-amber-400' :
                                        user.level === 'Tenente' ? 'text-blue-400' :
                                            'text-gray-400'
                                        }`}>
                                        {user.level}
                                    </span>
                                </td>
                                <td className="px-6 py-4 font-mono text-white">
                                    {user.spent}
                                </td>
                                <td className="px-6 py-4">
                                    <button className="text-arsenal-red hover:text-white transition-colors text-xs font-bold uppercase hover:underline">
                                        Inspecionar
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AdminUsers;
